// extracted by mini-css-extract-plugin
module.exports = {"term":"term_term__6qQbY","btn":"term_btn__1T__x","content":"term_content__1jFTt"};